import { render } from "./Cranio.vue?vue&type=template&id=f02a4cc6"
import script from "./Cranio.vue?vue&type=script&lang=js"
export * from "./Cranio.vue?vue&type=script&lang=js"

import "./Cranio.vue?vue&type=style&index=0&id=f02a4cc6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__